import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {SpacerBuildInControl} from '../SpacerBuildInControl';

export abstract class SpacerMarginsBuiltInControl extends SpacerBuildInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_SPACER].EXTERNAL_INDENTS;
  }
}
